<template>
    <div class="orderChargeOff">
        <div class="top_box spackage padding-20 bgc box-shadow">
            <div class="input_box">
                <el-input @keyup.enter.native="enterBtn" v-model="verificationCode" placeholder="请输入核销码或是扫码自动填入"></el-input>
                <el-button @click="enterBtn()" type="primary" plain><img :src="require('@/common/images/communityPurchases/enter.png')" alt="">ENTER</el-button>
            </div>
        </div>
        <div class="content_box spackage bgc box-shadow">
            <div class="search_box">
                <div class="left_box">已核订单</div>
                <div class="right_box">
                    <el-input v-model="orderNo" placeholder="请输入订单号"></el-input>
                    <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
                </div>
            </div>
            <div class="order_table_box">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column property="orderno" label="订单号"></el-table-column>
                    <el-table-column label="用户名称">
                        <template slot-scope="scope">
                            <div class="user_box">
                                <img :src="scope.row.customericonurl" alt="">
                                <span>{{scope.row.customername}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="assname" label="社群名称" align='center'></el-table-column>
                    <el-table-column property="eventname" label="活动名称" align='center'></el-table-column>
                    <el-table-column property="productcount" label="商品数" align='center'></el-table-column>
                    <el-table-column property="orderprice" label="订单金额" align='center'></el-table-column>
                    <el-table-column property="ordertime" label="订单时间" align='center' width="180"></el-table-column>
                    <el-table-column property="checktime" label="核销时间" align='center' width="180"></el-table-column>
                    <el-table-column label="操作" align='center'>
                        <template slot-scope="scope">
                            <el-button type="text" @click="detailsBtn(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <page :total="total" ref="page" @getList="getOrderList"></page>
            </div>
            <div class="charge_off_pop">
                <!-- <ChargeOffPop ref="chargeoffpop" :orderInfo="orderInfo"></ChargeOffPop> -->
                <el-dialog @close='closeDialog' title="订单详情" :visible.sync="dialogVisible">
                    <div class="charge_off_info_warp">
                        <div class="top_user_info_box">
                            <div>
                                <div>
                                    <img :src="orderInfo.info.customericonurl" alt="">
                                    <span>{{orderInfo.info.customername}}</span>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>活动名称：</label>
                                    <span>{{orderInfo.info.eventname}}</span>
                                </div>
                                <div>
                                    <label>订单号：</label>
                                    <span>{{orderInfo.info.orderno}}</span>
                                </div>
                                <div>
                                    <label>订单状态：</label>
                                    <span :class="statusClass(orderInfo.info.orderstatustext)">{{orderInfo.info.orderstatustext}}</span>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>所在社群：</label>
                                    <span>{{orderInfo.info.assname}}</span>
                                </div>
                                <div>
                                    <label>订单金额：</label>
                                    <span>¥{{orderInfo.info.orderprice}}</span>
                                </div>
                                <div>
                                    <label>订单时间：</label>
                                    <span>{{orderInfo.info.ordertime}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="title_box">
                            <p>商品详情</p>
                        </div>
                        <div class="table_box">
                            <el-table :data="orderInfo.info.productlist" style="width: 100%" max-height="460">
                                <el-table-column label="商品名称" width="380">
                                    <template slot-scope="scope">
                                        <div class="goods_info_box">
                                            <img :src="scope.row.coveratturlid" alt="">
                                            <span>{{scope.row.productname}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column property="saleprice" label="商品单价" align='center'></el-table-column>
                                <el-table-column property="salecount" label="商品数量" align='center'></el-table-column>
                            </el-table>
                        </div>
                        <div v-if="orderInfo.type === 0 && orderInfo.info.ischeck === 1" class="tip_text_box">该订单已被核销</div>
                        <div v-if="orderInfo.type === 0 && orderInfo.info.ischeck === 0" slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">暂不核销</el-button>
                            <el-button type="primary" @click="sureClick()">确认核销</el-button>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import Page from 'base/page/page'
// import ChargeOffPop from 'views/communityPurchase/managementOfPurchaseAndPurchase/components/ChargeOffPop'
import {getCheckEventOrder, getOrderInfoByLineCode, updateEventOrderByCheck} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'OrderChargeOff',
    data() {
        return {
            dialogVisible: false,
            orderInfo: {
                type: '',
                info: {
                    productlist: []
                }
            },
            verificationCode: '',
            orderNo: '',
            total: 0,
            tableData: []
        }
    },
    mounted() {
        this.findChargeOffList()
    },
    methods: {
        // 订单核销查询按钮
        enterBtn() {
            if (this.verificationCode === '') {
                this.$message.error('请输入订单核销码')
            } else {
                this.orderInfo.type = 0
                // this.$refs.chargeoffpop.openDialog()
                // this.openDialog()
                this.findChargeOffInfo(this.verificationCode)
            }
        },
        // 分页及搜索
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        getOrderList() {
            this.setLoading(true)
            var params = {
                orderno: this.orderNo
            }
            getCheckEventOrder({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 订单核销已核销订单列表
        findChargeOffList() {
            this.setLoading(true)
            getCheckEventOrder({
                data: Object.assign({}, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 核销订单详情按钮
        detailsBtn(val) {
            // console.log(val)
            // this.$refs.chargeoffpop.openDialog()
            // this.openDialog()
            this.orderInfo.type = 1
            this.findChargeOffInfo(val.linecode)
        },

        // 查询核销订单信息
        findChargeOffInfo(val) {
            if (!val) {
                this.setLoading(true)
            }
            var params = {
                linecode: val
            }
            getOrderInfoByLineCode({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.orderInfo.info = data.data
                    this.openDialog()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 打开 弹窗
        openDialog() {
            this.dialogVisible = true
        },
        // 关闭 弹框
        closeDialog() {
            this.dialogVisible = false
        },
        // 确定核销按钮
        sureClick() {
            this.setLoading(true)
            var params = {
                linecode: this.verificationCode
            }
            updateEventOrderByCheck({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.closeDialog()
                    this.findChargeOffList()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        statusClass(value) {
            if (value === '待支付' || value === '待核销') {
                return 'dzf'
            } else if (value === '已完成' || value === '已核销') {
                return 'ywc'
            } else if (value === '已取消') {
                return 'yqx'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
        // ChargeOffPop
    }
}
</script>

<style lang="scss" type="text/scss">
.orderChargeOff{
    .top_box{
        margin-bottom: 24px;
        box-sizing: border-box;
        height: 146px;
        display: flex;
        justify-content: center;
        align-items: center;
        .input_box{
            position: relative;
            width: 700px;
            display: flex;
            align-items: center;
            .el-input {
                height: 60px;
                .el-input__inner {
                    height: 60px;
                    line-height: 60px;
                }
            }
            .el-button{
                width: 108px;
                height: 46px;
                position: absolute;
                top: 7px;
                right: 7px;
                span{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 18px;
                        height: 14px;
                        margin-right: 4px;
                    }
                }
            }
            .el-button--primary.is-plain:active {
                background: #ecf5ff;
                border-color: #3a8ee6;
                color: #409EFF;
            }
            .el-button--primary.is-plain:hover {
                background: #ecf5ff;
                border-color: #3a8ee6;
                color: #409EFF;
            }
            .el-button--primary.is-plain:focus {
                background: #ecf5ff;
                border-color: #3a8ee6;
                color: #409EFF;
            }
        }
    }
    .content_box{
        padding: 16px 20px 20px 20px;
        .search_box{
            position: relative;
            display: flex;
            justify-content: flex-end;
            border-bottom: #DCDFE6 solid 2px;
            .left_box{
                position: absolute;
                bottom: -2px;
                left: 0;
                width: 56px;
                text-align: center;
                color: #409EFF;
                display: flex;
                align-items: flex-end;
                padding-bottom: 12px;
                border-bottom: #409EFF solid 2px;
            }
            .right_box{
                padding-bottom: 16px;
                display: flex;
                .el-input {
                    width: 240px;
                    margin-right: 30px;
                    .el-input__inner {
                        height: 36px;
                        line-height: 36px;
                    }
                }
                .el-button{
                    height: 36px;
                }

            }
        }
        .order_table_box{
            margin-top: 30px;
            .el-table th>.cell {
                font-weight: bold!important;
                white-space: nowrap;
                font-size: 16px;
            }
            .el-table__empty-block {
                min-height: 500px;
            }
            .user_box{
                display: flex;
                align-items: center;
                img{
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
        }
        .charge_off_pop{
            .el-dialog__wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: left;
            }
            .el-dialog {
                width: 900px;
                margin: 0!important;
            }
            .el-dialog .el-dialog__body {
                padding: 0px!important;
                height: 100%;
            }
            .charge_off_info_warp{
                background-color: rgb(255, 255, 255);
                // min-height: 600px;
                .top_user_info_box{
                    // padding: 30px;
                    padding: 20px;
                    &>div{
                        display: flex;
                        margin-top: 10px;
                        &>div{
                            width: 28%;
                            display: flex;
                            align-items: center;
                            img{
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                margin-right: 10px;
                            }
                            label{
                                color: #606266;
                            }
                            span{
                                color: #303133;
                            }
                            .ywc {
                                color: #67C23A;
                            }
                            .dzf {
                                color: #E6A23C;
                            }
                            .yqx {
                                color: #606266;
                            }
                        }
                        &>div:nth-of-type(1){
                            width: 44%;
                        }
                    }
                    &>div:nth-of-type(1){
                        margin-top: 0;
                        margin-bottom: 20px;
                    }
                }
                .title_box{
                    // margin-bottom: 30px;
                    margin-bottom: 20px;
                    height: 46px;
                    border-bottom: 2px solid #DCDFE6;
                    position: relative;
                    p{
                        color: #409EFF;
                        position: absolute;
                        bottom: -2px;
                        left: 20px;
                        padding-bottom: 14px;
                        border-bottom: 2px solid #409EFF;
                    }
                }
                .table_box{
                    // min-height: 320px;
                    margin-bottom: 30px;
                    padding: 0 10px;
                    .el-table th>.cell {
                        font-weight: bold!important;
                        white-space: nowrap;
                        font-size: 16px;
                    }
                    .el-table__body-wrapper {
                        min-height: 350px;
                    }
                    .el-table__empty-block {
                        box-sizing: border-box;
                        padding-top: 140px;
                        min-height: 280px;
                        background-size: 300px 230px !important;
                    }
                    .goods_info_box{
                        display: flex;
                        justify-content: flex-start;
                        img{
                            width: 106px;
                            height: 60px;
                            margin-right: 10px;
                        }
                    }
                }
                .tip_text_box{
                    margin-bottom: 30px;
                    text-align: center;
                    color: #F56C6C;
                }
            }
        }
    }
}
</style>